/**
 * MOSTRADOR DE PRECIOS v4.1 - TIMING ARREGLADO
 * Espera correctamente a que los badges se carguen
 * StudioJohan
 */

(function() {
  'use strict';
  
  const DEBUG = true;
  
  function log(message, data = '') {
    if (DEBUG) {
      console.log(`[Price v4.1] ${message}`, data);
    }
  }
  
  class PriceDisplayFixed {
    constructor() {
      this.processedElements = new WeakSet();
      this.init();
    }
    
    init() {
      log('🚀 Starting Price Display v4.1...');
      this.scheduleProcessing();
      this.observeDOM();
    }
    
    scheduleProcessing() {
      // Esperar a que los badges se carguen completamente
      setTimeout(() => this.processAllPrices(), 2000);
      setTimeout(() => this.processAllPrices(), 3000);
      setTimeout(() => this.processAllPrices(), 4000);
    }
    
    formatPrice(price) {
      return price.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    
    extractPrice(element) {
      const text = element.textContent.trim();
      
      // Buscar patrón de precio: $XX.XX o $XX,XX
      const patterns = [
        /\$\s*(\d{1,3}(?:[.,]\d{2}))/,  // $39.99 o $39,99
        /\$\s*(\d+)/                     // $39
      ];
      
      for (const pattern of patterns) {
        const match = text.match(pattern);
        if (match) {
          let numStr = match[1].replace(',', '.');
          let price = parseFloat(numStr);
          
          // Validar precio
          if (!isNaN(price) && price > 0 && price < 1000000) {
            return price;
          }
        }
      }
      
      return null;
    }
    
    getCurrency(text) {
      if (text.includes('USD')) return ' USD';
      if (text.includes('COP')) return ' COP';
      return '';
    }
    
    findValidPriceElements() {
      const found = [];
      
      // Solo buscar precios regulares
      const selectors = [
        '.price__regular .price-item--regular',
        '.price-item.price-item--regular:not(.price-item--sale)'
      ];
      
      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          // Verificar que no esté dentro de precio de venta
          if (el.closest('.price__sale')) return;
          
          // Verificar que no esté procesado
          if (el.classList.contains('price-processed')) return;
          if (this.processedElements.has(el)) return;
          
          // Verificar que sea visible
          if (el.offsetParent === null) return;
          
          // Verificar precio válido
          const price = this.extractPrice(el);
          if (!price) return;
          
          found.push(el);
        });
      });
      
      return found;
    }
    
    findProductContainer(priceElement) {
      const selectors = [
        '.product',
        '.product-card', 
        '.card-wrapper',
        '.card',
        'article',
        'li[class*="product"]',
        '.product__media-item'
      ];
      
      for (const selector of selectors) {
        const container = priceElement.closest(selector);
        if (container && container.querySelector('.shopify-discount-badge')) {
          return container;
        }
      }
      
      // Buscar subiendo manualmente
      let current = priceElement.parentElement;
      for (let i = 0; i < 10; i++) {
        if (!current) break;
        if (current.querySelector('.shopify-discount-badge')) {
          return current;
        }
        current = current.parentElement;
      }
      
      return null;
    }
    
    getDiscount(container) {
      if (!container) return 0;
      
      const badge = container.querySelector('.shopify-discount-badge');
      if (!badge) return 0;
      
      const match = badge.textContent.match(/(\d+)%/);
      return match ? parseInt(match[1]) : 0;
    }
    
    updatePrice(element, discount) {
      // Marcar como procesado PRIMERO
      if (this.processedElements.has(element)) {
        return false;
      }
      this.processedElements.add(element);
      element.classList.add('price-processed');
      
      const originalPrice = this.extractPrice(element);
      if (!originalPrice) {
        log('❌ No valid price found');
        return false;
      }
      
      const currency = this.getCurrency(element.textContent);
      const discountedPrice = originalPrice * (1 - discount / 100);
      
      log(`✅ ${discount}%: $${originalPrice} → $${discountedPrice.toFixed(2)}`);
      
      // Crear nuevo HTML
      element.innerHTML = `
        <span style="text-decoration: line-through; color: #999; font-size: 0.85em; margin-right: 8px;">
          $${this.formatPrice(originalPrice)}${currency}
        </span>
        <span style="color: #FF0000; font-weight: bold;">
          $${this.formatPrice(discountedPrice)}${currency}
        </span>
      `;
      
      return true;
    }
    
    processAllPrices() {
      // Verificar que haya badges primero
      const badgeCount = document.querySelectorAll('.shopify-discount-badge').length;
      
      if (badgeCount === 0) {
        log('⚠️ No badges found yet, skipping...');
        return;
      }
      
      log(`🔍 Found ${badgeCount} badges, processing prices...`);
      
      const elements = this.findValidPriceElements();
      log(`📊 Found ${elements.length} valid price elements`);
      
      let updated = 0;
      
      elements.forEach(el => {
        const container = this.findProductContainer(el);
        const discount = this.getDiscount(container);
        
        if (discount > 0) {
          if (this.updatePrice(el, discount)) {
            updated++;
          }
        }
      });
      
      log(`✨ Updated ${updated} prices`);
    }
    
    observeDOM() {
      const observer = new MutationObserver(() => {
        setTimeout(() => this.processAllPrices(), 500);
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      log('👁️ Observer active');
    }
  }
  
  // Esperar a que TODO esté listo
  function waitForEverything() {
    let attempts = 0;
    const maxAttempts = 50; // 50 intentos = 10 segundos
    
    const check = setInterval(() => {
      attempts++;
      const badgeCount = document.querySelectorAll('.shopify-discount-badge').length;
      
      if (badgeCount > 0) {
        clearInterval(check);
        log(`✅ Found ${badgeCount} badges after ${attempts} attempts`);
        window.priceDisplay = new PriceDisplayFixed();
      } else if (attempts >= maxAttempts) {
        clearInterval(check);
        log('⏰ Timeout - starting anyway');
        window.priceDisplay = new PriceDisplayFixed();
      }
    }, 200);
  }
  
  // Inicializar cuando el DOM esté completamente listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(waitForEverything, 500);
    });
  } else {
    setTimeout(waitForEverything, 500);
  }
  
})();